import { buildMrApiToken } from '~/utils/jwt/authToken';
import { useAccountStore } from '~/stores/accountStore';

export default defineNuxtRouteMiddleware(async () => {
    if (!import.meta.server) {
        return;
    }

    const accountStore = useAccountStore();
    await buildMrApiToken(
        useRuntimeConfig().jwtPrivateKey.replace(/\\n/g, '\n'),
        accountStore.state.id,
    );
});
